var updateCart = {
	DOMCartTotal: '#cartTotal',
	DOMArticles: '#articleCount',
	cartContainer: '.cart-stuff',
	
	addToCart : function (button, articleId) {
		var cartTotal = jQuery(this.DOMCartTotal);
		var articles = jQuery(this.DOMArticles);
		var purchaseButton = jQuery(button).children('#purchase');
		var originalPurchaseButton = purchaseButton.val();
		var cartContainer = jQuery(this.cartContainer);

		purchaseButton.val(Shopify.cart_add_loading);
		purchaseButton.attr('disabled', 'disabled');
		jQuery.ajax({
			url: "/cart/add.js",
			type: 'POST',
			data: {
				id: articleId,
			},
			complete: function(data) {
				if(data.responseText)
					data = JSON.parse(data.responseText);
				
				// When done, perform the get cart call
				jQuery.ajax({
					url: "/cart.js",
					complete: function(data) {
						if(data.responseText)
							data = JSON.parse(data.responseText);
						
						cartTotal.html(Shopify.formatMoney(data.total_price, Shopify.money_format));
						articles.html(data.item_count);
						purchaseButton.val(originalPurchaseButton);
						purchaseButton.removeAttr('disabled');
						cartContainer.stop().effect("highlight", { color: "#5B2B3B" }, 900);
					}
				});
			}
		});
	}
}